import { Button } from '@planuze/ui';
import { useSupportInboxContent } from '../../content/sections/support-inbox.js';
import { BulkSelectionBar } from '../bulk-selection-bar.js';

interface Props {
  readonly selectedCount: number;
  readonly busy: boolean;
  readonly onAssign: () => void;
  readonly onClose: () => void;
  readonly onClear: () => void;
}

export function SupportBulkBar({ selectedCount, busy, onAssign, onClose, onClear }: Props) {
  const copy = useSupportInboxContent().bulk;
  if (selectedCount === 0) return null;
  return (
    <BulkSelectionBar
      selectedLabel={copy.selectedCount(selectedCount)}
      clearLabel={copy.clear}
      busy={busy}
      onClear={onClear}
    >
      <Button size="sm" disabled={busy} onClick={onAssign}>
        {copy.assign}
      </Button>
      <Button size="sm" variant="destructive" disabled={busy} onClick={onClose}>
        {copy.close}
      </Button>
    </BulkSelectionBar>
  );
}
